<style>
.el-collapse-item__header {
  padding-left: 15px;
}
.el-upload--picture-card {
  float: left;
  margin-right: 10px;
}
.circle-closesty {
  position: relative;
  top: -35px;
  margin-left: 112px;
  font-size: 20px;
  cursor: pointer;
}
.v-modal {
  z-index: 100 !important;
}
.select-box {
  overflow: hidden;
  margin: 0 0px 10px 30px;
}
.box-left {
  width: 40%;
  height: 350px;
  padding: 0 20px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
  overflow-y: auto;
}
.box-right {
  width: 57%;
  height: 350px;
  padding: 0 10px 20px 20px;
  border: 1px solid #bbb;
  box-sizing: border-box;
}

</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="24">
        <el-col :span="6">
          <div class="search-area-div">单位名称</div>
          <el-input v-model.trim="page.paramValue" size="mini" class="ipt-sty" placeholder="请输入任务单位"></el-input>
        </el-col>
        <el-col :span="6">
          <div class="search-area-div">单位类型</div>
          <el-select v-model="page.paramName" placeholder="单位类型" size="mini" class="ipt-sty">
            <el-option v-for="item in paramNameList" :key="item.paramName" :label="item.paramName" :value="item.paramName"></el-option>
          </el-select>
        </el-col>
        <el-col :span="6" class="search-btn-box">
          <el-button size="mini" type="info" @click="search">搜索</el-button>
          <el-button size="mini" type="danger" @click="emptySearch">清空</el-button>
        </el-col>
      </el-row>
    </div>

    <div class="back-color-fff content-main-box"  :style="'height:' + contentMainHeight + 'px;'">
      <div class="button-area">
        <el-button icon="el-icon-plus" size="mini" type="info" @click="addVersion">新增单位</el-button>
      </div>
      <el-table :data="tableData" boeder stripe border style="width: 100%" v-loading="tableLoading" :height="height">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{ (page.pageIndex - 1) * page.pageSize + scope.$index + 1 }}
          </template>
        </el-table-column>
        <el-table-column prop="paramName" label="单位类型" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.paramName }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="单位名称" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.paramValue }}</template>
        </el-table-column>
        <el-table-column prop="campaignsState" label="统计规则" show-overflow-tooltip header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.paramValue1 }}</template>
        </el-table-column>
     
        <el-table-column prop="createUserName" label="创建人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createUserName }}</template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.createTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="updateUserName" label="更新人" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateUserName||'-' }}</template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" header-align="center" align="left">
          <template slot-scope="scope">{{ scope.row.updateTime | getDate }}</template>
        </el-table-column>
        <el-table-column prop="bank" width="120px" label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="editVersion(scope.row)">编辑 ｜</a>
            <a class="txt-color" @click="delVersion(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination class="pt pb back-color-fff content-pagination-box" background @size-change="handleSizeChange" @current-change="handleCurrentChange" :page-sizes="[10, 20,50,100, 200]" :current-page="page.pageIndex" :page-size="page.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="page.totalRows">
    </el-pagination>
    <el-dialog :title="textTitle" :visible.sync="dialogVisible" width="800px">
      <el-form label-width="140px" :label-position="right" class="demo-ruleForm">
        <el-form-item v-if="textTitle!='编辑单位'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">单位类型 </span>
          <div class="unit-type">
            <el-radio-group v-model="paramName">
              <el-radio label="任务总量单位">任务总量单位</el-radio>
              <el-radio label="任务价格单位">任务价格单位</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item>
          <span slot="label" style="color: red">*</span>
          <span slot="label">任务单位 </span>
          <el-input type="input" :maxlength="30" :placeholder="paramName=='任务价格单位'?'例如: 元/次、元/家、元/盒于任务派发的报价单位展示。':'例如:次、家、盒，用于任派发的总量单位展示。'" v-model.trim="paramValue"> </el-input>
        </el-form-item>
        <el-form-item v-if="paramName=='任务总量单位'">
          <span slot="label" style="color: red">*</span>
          <span slot="label">统计规则<el-tooltip class="item" effect="dark">
                <div slot="content" style="overflow: hidden;">
                  说明：用于配置任务执行后统计的规则，比如：拜访按家统计，拜访一家，则完成量加一。
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip> </span>
          <el-radio-group v-model="paramValue1">
            <el-radio label="按次">按次</el-radio>
            <el-radio label="按家">按家</el-radio>
            <el-radio label="按产品数量">按产品数量</el-radio>
          
            <el-radio label="按是否已读">按是否已读</el-radio>
            <br/>
            <el-radio label="按人">按人
              <el-tooltip class="item" effect="dark">
                <div slot="content" style="overflow: hidden;">
                  同期拜访重复客户按一次计算
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-radio>
        
            <!-- 原来的按人数 -->
            <el-radio label="按人次">按人次
              <el-tooltip class="item" effect="dark">
                <div slot="content" style="overflow: hidden;">
                  同期拜访重复客户按多次计算，不去重
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-radio>
            <el-radio label="按家次">按家次
              <el-tooltip class="item" effect="dark">
                <div slot="content" style="overflow: hidden;">
                  比如企业要求业务员每周跑50家A类客户，每家必须跑2次，才算完成任务
                </div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </el-radio>

          </el-radio-group>
          <div style="text-align: left">说明：用于制定任务完成标准。</div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" plain @click="dialogVisible = false">取 消</el-button>
        <el-button size="medium" type="info" v-if="textTitle == '新增单位'" @click="addReqVersion" v-loading.fullscreen.lock="fullscreenLoading">确 定</el-button>
        <el-button size="medium" type="info" v-else @click="updateReqVersion" v-loading.fullscreen.lock="fullscreenLoading">修 改</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import { route } from '@/api/apiRoute';
  import store from '@/store';
  export default {
    data() {
      return {
        fullscreenLoading: false,
        textTitle: '新增单位',
        page: {
          pageIndex: 1,
          pageSize: 50,
          totalPage: 0,
          totalRows: 0,
          bizType: '任务单位',
          paramName: '', //单位类型
          paramValue: '', //任务单位
          tenantGuid: localStorage.guid,
          tenantName: JSON.parse(localStorage.userInfo).tenantName,
        },
        paramNameList: [{ paramName: '任务总量单位' }, { paramName: '任务价格单位' }],
        paramName: '',
        paramValue: '',
        paramValue1: '',
        isNewZiDuan: false,
        height: window.innerHeight - 260,
        contentMainHeight: window.innerHeight - 200,
        right: 'right',
        tableData: [],
        dialogVisible: false,
      };
    },
    created() {
      this.getList();
    },
    watch: {},
    methods: {
      search() {
        let self = this;
        this.page.pageIndex = 1;
        self.tableLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, this.page).then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      emptySearch() {
        this.page = {
          pageIndex: 1,
          pageSize: 10,
          totalPage: 0,
          totalRows: 0,
          bizType: '任务单位',
          paramName: '',
          tenantGuid: localStorage.guid,
          tenantName: JSON.parse(localStorage.userInfo).tenantName,
        };
        this.getList();
      },
      addVersion() {
        this.textTitle = '新增单位';
        this.paramName = '任务价格单位';
        this.paramValue = '';
        this.paramValue1 = '';
        this.dialogVisible = true;
      },
      editVersion(detail) {
        this.textTitle = '编辑单位';
        this.dialogVisible = true;
        this.guid = detail.guid;
        this.paramName = detail.paramName;
        this.paramValue = detail.paramValue;
        this.paramValue1 = detail.paramValue1=='按参会人数，仅用于RX会议任务统计'?'按参会人数':detail.paramValue1;
      },
      getList() {
        let self = this;
        self.tableLoading = true;
        self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/get-list`, this.page).then((res) => {
          self.tableLoading = false;
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.tableData = res.data.data.records;
            self.page.totalPage = res.data.data.totalPages;
            self.page.totalRows = res.data.data.totalRows;
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      delVersion(guid) {
        var self = this;
        self
          .$confirm('删除后不可恢复，确定删除吗？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
          .then(() => {
            self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/delete?guid=${guid}`).then((res) => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.page.pageIndex = 1;
                self.getList();
              } else {
                self.$message.error(res.data.msg);
              }
            });
          });
      },
      addReqVersion() {
        var self = this;
        if (!this.paramName) {
          self.$message('请选择单位类型');
          return;
        }
        if (!this.paramValue) {
          self.$message('请输入任务单位');
          return;
        }
        if (!this.paramValue1&&this.paramName=='任务总量单位') {
          self.$message('请选择统计规则');
          return;
        }
        var req = {
          paramName: this.paramName,
          paramValue1: this.paramName=='任务总量单位'?this.paramValue1:null,
          paramValue:this.paramValue.replace(' ',''),
          bizType: '任务单位',
          tenantGuid: localStorage.guid,
          tenantName: JSON.parse(localStorage.userInfo).tenantName,
        };

        self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.dialogVisible = false;
            self.$message.success('新增成功');
            self.page.pageIndex = 1;
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      updateReqVersion() {
        var self = this;
        if (!this.paramName) {
          self.$message('请选择单位类型');
          return;
        }
        if (!this.paramValue) {
          self.$message('请输入任务单位');
          return;
        }
        if (!this.paramValue1&&this.paramName=='任务总量单位') {
          self.$message('请选择统计规则');
          return;
        }
        var req = {
          bizType: '任务单位',
          paramName: this.paramName,
          paramValue1: this.paramName=='任务总量单位'?this.paramValue1:null,
          paramValue:this.paramValue.replace(' ',''),
          guid: this.guid,
          tenantGuid: localStorage.guid,
          tenantName: JSON.parse(localStorage.userInfo).tenantName,
        };
        self.api.postJson(`/${serverConfig.msSalesPerformService}/biz-param/data/edit`, req).then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            self.dialogVisible = false;
            self.$message.success('修改成功');
            self.getList();
          } else {
            self.$message.error(res.data.msg);
          }
        });
      },
      handleSizeChange(val) {
        let self = this;
        self.page.pageSize = val;
        this.getList();
      },
      handleCurrentChange(val) {
        let self = this;
        self.page.pageIndex = val;
        this.getList();
      },
    },
  };
</script> 
<style scoped>
 /deep/ .el-radio{
    margin-bottom:12px;
 }
 .unit-type  /deep/ .el-radio{
    margin-bottom: 0;
 }
.el-table /deep/ .el-input__inner {
  height: 40px;
  line-height: 40px;
}
.el-range-editor.el-input__inner {
  padding: 0px;
}
/* /deep/ .el-checkbox__label {
  display: none;
} */
.attach-sty {
  width: 170px;
  float: left;
  margin-top: 15px;
  text-align: center;
}
.checkbox-img-sty {
  border: 1px solid #dcdfe6;
  width: 16px;
  height: 16px;
  border-radius: 2px;
  cursor: pointer;
}
/deep/ .el-step__icon.is-text {
  border-radius: 50%;
  border-color: #4fa1a4;
  border-color: inherit;
}
/deep/ .el-step__icon-inner {
  color: #4fa1a4;
}
/deep/ .el-step__title.is-process {
  color: #4fa1a4;
}
/deep/ .el-form-item__content {
  text-align: left;
}
/deep/ .el-form-item__label {
  padding-right: 30px;
}
</style>